const text = `[[topSection]][[publisherName]] vindt je online privacy belangrijk. Wij informeren je daarom over het volgende.

Wij slaan op je apparaat gegevens op om deze website te laten functioneren. Je apparaat kan ook benaderd worden door [[thirdPartiesUrl]] voor vergelijkbare gegevensopslag.

Persoonlijke gegevens zoals je IP-adres en unieke identificatiecodes kunnen door ons en [[thirdPartiesUrl]] gebruikt worden voor de volgende doeleinden waarvoor [[thirdPartiesUrl]] jouw toestemming kunnen vragen:
[[purposes]]

Doeleinden waarvoor [[thirdPartiesUrl]] legitimate interest claimen zonder het recht op verzet:
[[legitimateInterest]]

En functionaliteiten waarvoor [[thirdPartiesUrl]] expliciet jouw opt-in nodig hebben:
[[features]]

Wij stellen deze interface beschikbaar om je controle te geven over je privacyinstellingen. Je kunt je privacyinstellingen op ieder moment tijdens je bezoek aan deze pagina aanpassen. Dat kun je doen in een dialoogvenster. Om dit dialoogvenster te openen, klik je op de Privacy-knop op je scherm.

Naast toestemming kunnen [[thirdPartiesUrl]] [[legitimateInterestUrl]] claimen als wettelijke basis voor het verwerken van persoonlijke gegevens. In de meeste gevallen heb je het recht om je hiertegen te verzetten. Een signaal om je verzet door te geven aan aangesloten partijen wordt beheerd middels deze interface.

Wij en [[totalVendors]] andere [[partnersScreen]] leden kunnen bij volledige acceptatie mogelijk informatie op uw apparaat opslaan en/of openen deze voor gepersonaliseerde advertenties en inhoud.

Als je geen toestemming geeft, kan dit leiden tot meer advertenties en advertenties die niet aansluiten bij jouw interesses.

Iedere toestemming, opt-in en verzet dat je instelt, is beperkt tot alleen deze website.

[[bottomSection]]
`;
export default text;
